// View "Calendário" — grade mensal 7×N com atividades exibidas no dia
// do data_vencimento, color-coded por status.
import { useState, useMemo } from 'react';
import { Card, Button, Typography, Flex } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { hojeIso } from '../../utils/dataFmt';
import { STATUS_LABEL } from './types';
import type { Atividade } from './types';

const { Text } = Typography;

interface Props {
  atividades: Atividade[];
  onEditar: (a: Atividade) => void;
}

export default function CalendarioAtividades({ atividades, onEditar }: Props) {
  const [mes, setMes] = useState(() => new Date());
  const porDia = useMemo(() => {
    const m: Record<string, Atividade[]> = {};
    for (const a of atividades) {
      if (!a.data_vencimento) continue;
      const d = a.data_vencimento.slice(0, 10);
      (m[d] = m[d] || []).push(a);
    }
    return m;
  }, [atividades]);

  const ano = mes.getFullYear();
  const mesNum = mes.getMonth();
  const primeiroDia = new Date(ano, mesNum, 1);
  const ultimoDia = new Date(ano, mesNum + 1, 0);
  const inicio = new Date(primeiroDia);
  inicio.setDate(inicio.getDate() - inicio.getDay());
  const dias: Date[] = [];
  for (let d = new Date(inicio); d <= ultimoDia || d.getDay() !== 0; d.setDate(d.getDate() + 1)) {
    dias.push(new Date(d));
    if (dias.length > 42) break;
  }
  const nomeMes = primeiroDia.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });

  return (
    <Card size="small">
      <Flex align="center" gap={12} style={{ marginBottom: 14 }}>
        <Button size="small" icon={<LeftOutlined />}
          onClick={() => setMes(m => new Date(m.getFullYear(), m.getMonth() - 1, 1))} />
        <Text strong style={{ fontSize: 14, color: '#020D7F', textTransform: 'capitalize' }}>{nomeMes}</Text>
        <Button size="small" icon={<RightOutlined />}
          onClick={() => setMes(m => new Date(m.getFullYear(), m.getMonth() + 1, 1))} />
        <Button size="small" onClick={() => setMes(new Date())}>Hoje</Button>
      </Flex>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 1, background: '#e0e0e0' }}>
        {['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map(d => (
          <div key={d} style={{
            background: '#020D7F', color: '#fff', padding: '6px 8px',
            fontSize: 10, fontWeight: 700, textAlign: 'center',
          }}>{d}</div>
        ))}
        {dias.map((d, i) => {
          const iso = d.toISOString().slice(0, 10);
          const atividadesDia = porDia[iso] || [];
          const noMes = d.getMonth() === mesNum;
          const hoje = iso === hojeIso();
          return (
            <div key={i} style={{
              background: hoje ? '#FFF8E8' : noMes ? '#fff' : '#fafafa',
              minHeight: 80, padding: 4, fontSize: 10,
              opacity: noMes ? 1 : 0.5,
            }}>
              <div style={{
                fontSize: 11, fontWeight: hoje ? 700 : 500,
                color: hoje ? '#B07500' : '#444', marginBottom: 2,
              }}>{d.getDate()}</div>
              {atividadesDia.map(a => (
                <div key={a.id} onClick={() => onEditar(a)}
                  style={{
                    padding: '2px 5px', marginBottom: 2, fontSize: 10,
                    background: STATUS_LABEL[a.status]?.bg || '#eef',
                    color: STATUS_LABEL[a.status]?.cor || '#333',
                    borderRadius: 3, cursor: 'pointer',
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                  }}>
                  {a.titulo}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
